var UnavailableScheduleModalEnum = /* @__PURE__ */ ((UnavailableScheduleModalEnum2) => {
  UnavailableScheduleModalEnum2["UNAVAILABLE_SCHEDULE_MODAL"] = "unavailable-schedule-modal";
  UnavailableScheduleModalEnum2["UNAVAILABLE_SCHEDULE_MODAL_CLOSE"] = "unavailable-schedule-modal-close";
  UnavailableScheduleModalEnum2["UNAVAILABLE_SCHEDULE_MODAL_TITLE"] = "unavailable-schedule-modal-title";
  UnavailableScheduleModalEnum2["UNAVAILABLE_SCHEDULE_MODAL_DESCRIPTION"] = "unavailable-schedule-modal-description";
  UnavailableScheduleModalEnum2["UNAVAILABLE_SCHEDULE_MODAL_CONFIRM_BUTTON"] = "unavailable-schedule-modal-confirm-button";
  return UnavailableScheduleModalEnum2;
})(UnavailableScheduleModalEnum || {});
export {
  UnavailableScheduleModalEnum
};
